<template>
  <article class="article">
    <a class="article-img-link" :href="article.items[0].target.expandedUri">
      <img
      class="article-img"
        v-if="article.items[0].image !== undefined"
        :src="article.items[0].image.imageAsset.urls[3].url"
      />
      <div
        class="img-placeholder"
        v-else-if="article.items[0].image === undefined"
      ></div>
    </a>
    <a class="article-title" :href="article.items[0].target.expandedUri">
      <p>{{ article.items[0].title.value }}</p>
    </a>
  </article>
</template>
<script>
export default {
  // https://mm.aftenbladet.no/backend/?type=collections&pub=sa&group=pages&tags=aa13c6e8-b10f-48e5-83f5-b2c910e43ae1
  props: {
    article: {
      type: Object,
      default: function() {
        return null;
      },
    },
  },
};
</script>
<style lang="scss">
.article {
  width: 100%;
  max-width: 300px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  &:hover {
    text-decoration: underline;
  }
}

.article-img-link {
  width: auto;
}

.article-img {
  max-width: 100%;
}

.img-placeholder {
  width: 300px;
  // width: 100%;
  height: 169px;
  background-color: #cccccc;
}
.article-title {
  width: 300px;
  text-decoration: none;
  color: #fff;
  font-weight: 600;
  font-size: 1.1em;
  
  p {
    margin: 0;
    margin-top: 0.9rem;
  }
}
</style>
